import React from 'react';
import { Box, Typography } from '@mui/material';

const DocumentSection = ({ section, index }) => {
  return (
    <Box id={section.id} sx={{ mb: 4 }}>
      <Typography 
        variant="h4" 
        component="h2" 
        sx={{ 
          mb: 2, 
          fontWeight: 'bold',
          color: 'primary.main',
          scrollMarginTop: '20px' // For smooth scrolling offset
        }}
      >
        {index}. {section.title}
      </Typography>

      {section.subsections ? (
        section.subsections.map((subsection, subIndex) => (
          <Box key={subsection.id} sx={{ mb: 3, ml: 2 }}>
            <Typography 
              variant="h5" 
              component="h3" 
              sx={{ mb: 1, fontWeight: 'bold' }}
              id={subsection.id}
            >
              {index}.{subIndex + 1} {subsection.title}
            </Typography>
            
            {Array.isArray(subsection.content) ? (
              subsection.content.map((paragraph, pIndex) => (
                <Typography 
                  key={pIndex}
                  variant="body1" 
                  sx={{ mb: 2, lineHeight: 1.7 }}
                >
                  {paragraph}
                </Typography>
              ))
            ) : (
              <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
                {subsection.content}
              </Typography>
            )}

            {subsection.list && (
              <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                {subsection.list.map((item, itemIndex) => (
                  <Typography 
                    key={itemIndex}
                    component="li" 
                    variant="body1" 
                    sx={{ mb: 1, lineHeight: 1.7 }}
                  >
                    {item}
                  </Typography>
                ))}
              </Box>
            )}
          </Box>
        ))
      ) : (
        <>
          {Array.isArray(section.content) ? (
            section.content.map((paragraph, pIndex) => (
              <Typography 
                key={pIndex}
                variant="body1" 
                sx={{ mb: 2, lineHeight: 1.7 }}
              >
                {paragraph}
              </Typography>
            ))
          ) : (
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
              {section.content}
            </Typography>
          )}

          {section.list && (
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              {section.list.map((item, itemIndex) => (
                <Typography 
                  key={itemIndex}
                  component="li" 
                  variant="body1" 
                  sx={{ mb: 1, lineHeight: 1.7 }}
                >
                  {item}
                </Typography>
              ))}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default DocumentSection;